import { Action } from '@ngrx/store';
import { Dealer } from '@polaris-customerweb/sharedcomponents.map';

export const DealerAction = {
    setActiveDealer: '[dealer] set active dealer',
    setDealers: '[dealer] set dealers',
};

export class SetActiveDealer implements Action {
    type = DealerAction.setActiveDealer;
    constructor(public dealer: Dealer | undefined) {}
}

export class SetDealers implements Action {
    type = DealerAction.setDealers;
    constructor(public dealers: Dealer[]) {}
}
